module.exports = __webpack_public_path__ + "static/media/Q2.985a8a35.jpg";